"use client";

// The last-resort error boundary: an error in the root layout itself, or in
// a route with no error.tsx of its own (the staff area, the signed-out pages).
// It replaces the root layout, so it brings its own <html> and can't use
// next-intl (the provider is gone): a short bilingual line, a retry, and a
// report to Conductor telemetry (lib/telemetry/browser.ts) whose digest links
// it to the server's onRequestError event. The raw message is never shown.
import { useEffect } from "react";

import { reportBrowserError } from "@/lib/telemetry/browser";

import "./globals.css";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
    reportBrowserError(error, {
      handled: false,
      level: "fatal",
      digest: error.digest,
      where: "global-error",
      force: true,
    });
  }, [error]);

  return (
    <html lang="it" className="light h-full antialiased">
      <body className="flex min-h-full flex-col items-center justify-center px-4 py-20 text-center font-sans">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          Qualcosa è andato storto · Something went wrong
        </h1>
        <p className="mx-auto mt-2 max-w-prose text-muted-foreground">
          Riprova tra un momento. · Please try again in a moment.
        </p>
        <button
          type="button"
          onClick={reset}
          className="mt-8 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-opacity hover:opacity-90"
        >
          Riprova · Try again
        </button>
      </body>
    </html>
  );
}
